// PDFViewer.js
import React from 'react';
import MegazinePdfThree from "../pdf/SPECIALIST_ACC_2014_2.pdf";
const PdfViewerThree = () => {

  return (
    <div className="pdf-viewer mobile" >

          <div className="pdf-viewer">
            <object data={MegazinePdfThree} type="application/pdf" width="100%" height="800">
              <embed src={MegazinePdfThree} type="application/pdf" width="100%" height="800" />
            </object>
          </div>

    </div>
  );
};

export default PdfViewerThree;
